<template>
  <v-row justify="center">
    <v-dialog @click:outside="close()" v-model="show" max-width="350px">
      <v-card>
        <v-card-title class="text-wrap" style="justify-content: center;">{{ active ? $t("user.disable") : $t("user.reactive") }}</v-card-title>
        <v-card-text class="pb-0">{{ active ? $t("user.askValidationDisable") : $t('user.askValidationReactive')}}</v-card-text>
        <v-card-actions class="pa-0 mt-4">
          <v-btn
              color="primary"
              tile
              @click="validate()"
              style="width: 50%;"
          >{{$t('return.validate')}}</v-btn>
          <v-btn
              color="secondary"
              tile
              class="ml-0"
              style="width: 50%;"
              @click="close()"
          >{{$t("return.close")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "ConfirmationDisabledReactiveUser",
  props: {
    value: {
      required: true
    },
    active: {
      required: true
    }
  },
  data(){
    return{

    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    validate(){
      this.$emit("validate")
      this.show = false
    },
    close(){
      this.$emit("close")
    },
  }
}
</script>

<style>

</style>
